const MARKETPLACE_API_PREFIX = '/api/marketplace';
const normalizeResource = (resource: string) => resource.replace(/^\/+|\/+$/g, '');

export const buildMarketplaceApiPath = (resource: string) => {
    return `${MARKETPLACE_API_PREFIX}/${normalizeResource(resource)}`;
};
